import {BaseRequestParams, CommonResponse, GetParamsType, GetSingleParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {UserNotifyState, UserResponse, UsersResponse} from "../models/response"

export const userApi = {
    getUsers(params?: GetParamsType & UsersFilterQuery): Promise<CommonResponse<UsersResponse>>
    {
        const paramsString = filterToString(params)
        return instance.get(`User${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    getUser(params: GetSingleParamsType): Promise<CommonResponse<UserResponse>>
    {
        const {id, controller} = params
        return instance.get(`User/${id}`, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    createUser(form: CreateUserType): Promise<CommonResponse<UserResponse>>
    {
        const {controller, ...rest} = form
        return instance.post(`User`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    changeUser(form: ChangeUserType): Promise<CommonResponse<UserResponse>>
    {
        const {id, controller, ...rest} = form
        return instance.put(`User/${id}`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
    deleteUser(id: number): Promise<CommonResponse<boolean>>
    {
        return instance.delete(`User/${id}`).then((res: AxiosResponse) => res.data)
    },
    changeUserSettings(form: ChangeUserSettingsType): Promise<CommonResponse<UserResponse>>
    {
        const {controller, ...rest} = form
        return instance.post(`User/settings`, {...rest}, {signal: controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}

export type UsersFilterQuery = {
    idCompany?: number
    idUserGroup?: number
    idUserType?: number
    search?: string
}

export type CreateUserType = {
    name: string
    phone: string
    telegramId: string
    idUserType: number
    idUserGroup: number
    email: string
    password: string
    active: boolean
} & BaseRequestParams

export type ChangeUserType = {
    id: number
    name: string
    phone: string
    telegramId: string
    idUserType: number
    idUserGroup: number
    active: boolean
} & BaseRequestParams

export type ChangeUserSettingsType = {
    notify: UserNotifyState
} & BaseRequestParams